// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6bBpg","questions":"styles_questions__3n5Dd","footer":"styles_footer__3f5YU"};